<template>
<svg xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 70.402 70.402">
  <g id="Group_321" data-name="Group 321" transform="translate(-35.496 -280.286)">
    <circle id="Ellipse_90" data-name="Ellipse 90" cx="35.201" cy="35.201" r="35.201" transform="translate(35.496 280.286)" fill="#fff"/>
    <g id="Group_137" data-name="Group 137" transform="translate(0 -850.394)">
      <path id="Path_239" data-name="Path 239" d="M81.148,1158.241a15.107,15.107,0,1,1-15.106-15.107,15.108,15.108,0,0,1,15.106,15.107" fill="none" stroke="#1a1818" stroke-miterlimit="10" stroke-width="3"/>
      <line id="Line_23" data-name="Line 23" x2="13.61" y2="13.61" transform="translate(75.866 1169.321)" fill="none" stroke="#1a1818" stroke-miterlimit="10" stroke-width="3"/>
      <line id="Line_24" data-name="Line 24" x2="9.849" y2="9.849" transform="translate(79.627 1173.082)" fill="none" stroke="#1a1818" stroke-miterlimit="10" stroke-width="9"/>
      <path id="Path_240" data-name="Path 240" d="M62.684,1170.325a8.048,8.048,0,1,1-8.047-8.048,8.048,8.048,0,0,1,8.047,8.048" fill="#fff" stroke="#1a1818" stroke-miterlimit="10" stroke-width="3"/>
      <path id="Path_241" data-name="Path 241" d="M82.671,1170.2" fill="#fff" stroke="#73c19d" stroke-miterlimit="10" stroke-width="3"/>
      <g id="Group_136" data-name="Group 136">
        <path id="Path_242" data-name="Path 242" d="M67.868,1156.183a3.62,3.62,0,0,0,.418-.247c.054-.035.1-.075.156-.113.089-.066.174-.137.256-.21a4.005,4.005,0,1,0-5.69-.521c.041.052.083.1.127.154.084.094.168.184.26.269a4.187,4.187,0,0,0,.37.306c.053.038.1.078.157.114a3.97,3.97,0,0,0,.423.248,6.113,6.113,0,0,0-4.188,3.9,7.588,7.588,0,0,1,4.65,5.181h8.106C72.913,1159.7,70.773,1156.934,67.868,1156.183Z" fill="#1a1818"/>
      </g>
      <path id="Path_243" data-name="Path 243" d="M64.835,1169.151" fill="none" stroke="#fff" stroke-miterlimit="10" stroke-width="3"/>
      <path id="Path_244" data-name="Path 244" d="M50.8,1169.935l2.849,2.849,5.171-5.171" fill="none" stroke="#1a1818" stroke-miterlimit="10" stroke-width="3"/>
    </g>
  </g>
</svg>
</template>

<script>
export default {
  'name': 'A_03',
  'props': {
    'size': {
      type: Number,
      default: 40
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/shared/icons/attributes/A_03.vue